import type { FaireProductEntity } from "../../entity_types/product";

export const p_g69c2c2tda: FaireProductEntity = {
  token: "p_g69c2c2tda",
  type: "product",
  name: "Bird Anatomy Posters",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/2825ddb19ef463afb4dc5255304e41b10d482affdc2646b6137013a5921a72cd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cda2b3b259ad800d9fc2ba502442a71184885447495c4693662280800547ffd7.jpeg",
    "https://cdn.faire.com/fastly/4b5f02379798e6f050ee2c22c9435a2a1a2c3b4d7c1475307e3cba0befb9b9f2.jpeg",
    "https://cdn.faire.com/fastly/f8cbcc6b4a1ce744fbead3843b22c313d8fcecd1f60b6fcaa00692e29803457f.jpeg",
    "https://cdn.faire.com/fastly/c233695c34c62c036ee69a6c35caaddc917800a3a9ee2ae82da402ef7004f590.jpeg",
    "https://cdn.faire.com/fastly/6a939799f59a1f25d3c3348188f72b1dd51b2fc80a96e9a54c462045d828cbbd.jpeg",
    "https://cdn.faire.com/fastly/b37c1e3b8e81d99617b6dbd7b45b127cf88f6f2d448c1fc0c41def2bdb4a488d.jpeg",
    "https://cdn.faire.com/fastly/b3c3d1d372feb6a04faf45afddca6f9693a85e7c8eb29f0ca54b75bc86b94b4a.jpeg",
    "https://cdn.faire.com/fastly/e85fb6eb4af2251683163d7530d20cd5908e1f4a7cea4474b0ca900008aa450c.jpeg",
    "https://cdn.faire.com/fastly/cb22bbf3a3df9763295f11eef78ad876d57eba97d8ad5a57628fc74b3987f90c.jpeg",
    "https://cdn.faire.com/fastly/d3c2e8b402e5621e88a9d46072c8fe91f2d7124f7a96ec8f883871b7f414234d.jpeg"
  ],
  priceDollars: 10,
  description: "Celebrate the beauty of birds with 28 ready-to-hang posters from beloved illustrator Julia Rothman. _Bird Anatomy Posters_ brings the best of the avian world into your home with 28 works of art. With 25 10 x 12 inches ready-to-hang posters and 3 19 x 24 inches fold-out posters, Julia Rothman’s stunning illustrations capture the wonder and joy of birds. From the beauty of murmuration of starlings across a sunset sky to the intricacy of a blue jay feather, the posters capture the unique splendor of the bird world, celebrating the diverse range of avian life, whether it’s a friendly backyard chickadee or an immense snowy albatross. Printed on sturdy, matte paper, these high-quality art posters are the perfect way to add color and delight to your own nest; tack them up on the wall, frame them, or gift them to the bird lovers in your life. Whether you’re a birding enthusiast delighted by a poster of capturing all the highest flying birds or a city-dweller who simply needs a strutting fancy pigeon on your wall, _Bird Anatomy Posters_ has something for everyone.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:54.605Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
